export default __webpack_public_path__ + "/dist/images/subscription-active.d667b2e2c39b072a3e978395b2ff0ba5.svg";